import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'mdcr-agreements-links',
  imports: [RouterModule],
  templateUrl: './agreements-links.component.html',
  styleUrl: './agreements-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgreementsLinksComponent {
  public readonly hideLinks = input<boolean>(false);
}
